import { theme } from '@lomadee/design-system';

import styled, { css } from 'styled-components';
import { Flex, Text } from 'rebass';
import { ComponentProps } from 'react';

interface IPositionedElement {
  top?: string;
  right?: string;
  left?: string;
}

export const PositionedElement = styled.div<ComponentProps<'div'> & IPositionedElement>`
  position: absolute;
  top: ${({ top }): string => (top ? top : '0px')};
  right: ${({ right }): string => (right ? right : '')};
  left: ${({ left }): string => (left ? left : '')};

  @media screen and (max-width: 1180px) {
    position: absolute;

    right: ${({ right }): string => (right ? '15%' : '')};
    left: ${({ left }): string => (left ? '2%' : '')};
  }

  @media screen and (max-width: 950px) {
    display: none;
  }
`;

export const TextGreeting = styled(Text)`
  color: ${() => theme.colors.white};
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;

  @media screen and (max-width: 767px) {
    font-size: 20px;
    line-height: 24px;
    display: flex;
    justify-content: center;
    display: none;
  }
`;

export const TextAffliateOrganization = styled(Text)`
  color: ${() => theme.colors.white};
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 16px;
  font-weight: 400;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const TextAffliateUnknownOrganization = styled(Text)`
  color: ${() => theme.colors.white};
  font-size: 14px;
  line-height: 16px;
  margin-top: 16px;
  font-weight: 300;

  @media screen and (max-width: 767px) {
    font-size: 12px;
    text-align: center;

    & > a {
      font-size: 12px;
    }
  }
`;

export const TextFinishOnboarding = styled(Text)`
  width: 50%;
  color: ${() => theme.colors.white};
  font-size: 14px;
  line-height: 16px;
  font-weight: 300;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const CardDropdownContainer = styled.div`
  width: 400px;
  position: relative;
  margin: 12px 0;

  & > div > :nth-child(2){
    flex: 1;
  }
  
  @media screen and (max-width: 767px){
    display: none;

    font-size: 12px;
    width: 100%;

    & > div {
      height: 52px;
    }
  }
`;

interface iInputDropdownItem {
  active: boolean;
}

interface iInputDropdownWrapper {
  opened: boolean;
}

export const DropdownWrapper = styled.div<iInputDropdownWrapper>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;

  width: 100%;
  max-height: 450px;
  overflow-y: auto;

  display: flex;
  flex-direction: column;

  background: ${() => theme.colors.neutralHigh};

  box-shadow: ${() => theme.shadow.Level4};
  border-radius: 8px;

  opacity: ${({ opened }) => (opened ? 1 : 0)};
  pointer-events: ${({ opened }) => (opened ? 'all' : 'none')};

  transition: opacity 0.1s linear;
  z-index: 9999;
`;

export const DropdownItem = styled.div<iInputDropdownItem>`
  padding: 12px 16px;
  letter-spacing: -0.005em;

  background: ${() => theme.colors.white};
  border-left: 1px solid ${() => theme.colors.neutralHighMedium};
  border-right: 1px solid ${() => theme.colors.neutralHighMedium};

  &:first-of-type {
    border-top: 1px solid ${() => theme.colors.neutralHighMedium};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-of-type {
    border-bottom: 1px solid ${() => theme.colors.neutralHighMedium};
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    background: ${() => theme.colors.primaryLightest};
  }

  ${({ active }) =>
    active &&
    css`
      background: ${() => theme.colors.primaryLightest};
    `}

  cursor: pointer;
  transition: background 0.1s linear;
`;

export const FirstAdminText = styled(Text)`
  @media screen and (max-width: 1000px) {
    text-align: center;
    margin: auto;
  }
`;

export const OrganizationCard = styled(Flex)`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  width: auto;
  border: 2px solid transparent;
  border-radius: 8px;
  background-color: rgb(241, 242, 249);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 8px;
  padding: 16px;
  transition: border-color 0.2s, background-color 0.2s;
  gap: 20px;

  .avatar { 
    background-color: #fff!important;
  }
`;
